import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { GetGsmStockListPagingAndFilterResponse, GetGsmStockListPagingAndFilterResponseData, GetGsmStockListPagingAndFilterResponseItem, initialGetGsmStockListPagingAndFilterResponseData } from '../../../models/response/gsmStock/GetGsmStockListPagingAndFilterResponse';
import { GetGsmStockListPagingAndFilterRequest, initialGetGsmStockListPagingAndFilterRequest } from '../../../models/request/gsmStock/GetGsmStockListPagingAndFilterRequest';
import { GsmStockService } from '../../../services/GsmStockService';
import toast from "react-hot-toast";
import GsmStockListFilters from './Components/GsmStockListFilters';
import { DeleteGsmStockResponse } from '../../../models/response/gsmStock/DeleteGsmStockResponse';
import { ExportGsmStockListResponse } from '../../../models/response/gsmStock/ExportGsmStockListResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants } from '../../../components/ColumnFilter/columnFilterOptions';
import StatusBadge from '../../../components/StatusBadge';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const GsmStockList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > GSM Stok Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetGsmStockListPagingAndFilterResponseData>(initialGetGsmStockListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetGsmStockListPagingAndFilterRequest>(initialGetGsmStockListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'SIM Kart Durumu', name: 'gsmStatusName', order: 0, isVisible: true },
            { title: 'Telefon No', name: 'phone', order: 0, isVisible: true },
            { title: 'ICCID', name: 'iccId', order: 0, isVisible: true },
            { title: 'Operatör', name: 'gsmOperatorName', order: 0, isVisible: true },
            { title: 'Hat Tipi', name: 'gsmCardTypeName', order: 0, isVisible: true },
            { title: 'Abonelik Durumu', name: 'gsmCardStatusName', order: 0, isVisible: true },
            { title: 'Teslim Alış Tarihi', name: 'deliveryDateStr', order: 0, isVisible: true },
            { title: 'Söz. Başlangıç Tarihi', name: 'agreementStartDateStr', order: 0, isVisible: true },
            { title: 'Söz. Bitiş Tarihi', name: 'agreementEndDateStr', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteGsmStock = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.gsmStockId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteGsmStockResponse = await GsmStockService.deleteGsmStock(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateGsmStock = async (_id: string | undefined = undefined) => {
        navigate('/gsmStock/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].gsmStockId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetGsmStockListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetGsmStockListPagingAndFilterResponse = await GsmStockService.getGsmStockListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.gsmStockId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportGsmStockListResponse = await GsmStockService.exportGsmStockList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.gsmStockId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Oluşturan/güncelleyen bilgisi listede yok.
    // Tarihler ekranda gün.ay.yıl gösterilse de gerçek tarih alanına göre sıralanır.
    const sortableColumns = [
        'refNo', 'gsmStatusName', 'phone', 'iccId', 'gsmOperatorName',
        'gsmCardTypeName', 'gsmCardStatusName',
        'deliveryDateStr', 'agreementStartDateStr', 'agreementEndDateStr'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (GsmStockManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        gsmStatusName: { type: 'select', loadOptions: () => loadConstants('GSM_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        phone: { type: 'text' },
        iccId: { type: 'text' },
        gsmOperatorName: { type: 'select', loadOptions: () => loadConstants('GSM_OPERATOR') },
        gsmCardTypeName: { type: 'select', loadOptions: () => loadConstants('GSM_CARD_TYPE') },
        gsmCardStatusName: { type: 'select', loadOptions: () => loadConstants('GSM_CARD_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        deliveryDateStr: { type: 'date' },
        agreementStartDateStr: { type: 'date' },
        agreementEndDateStr: { type: 'date' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetGsmStockListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.gsmStockId)} onDoubleClick={() => updateGsmStock(item.gsmStockId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.gsmStockId)} onDoubleClick={() => updateGsmStock(item.gsmStockId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (column == "gsmStatusName" || column == "gsmCardStatusName") {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.gsmStockId)} onDoubleClick={() => updateGsmStock(item.gsmStockId)}><StatusBadge text={item2[column]} /></td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.gsmStockId)} onDoubleClick={() => updateGsmStock(item.gsmStockId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <GsmStockListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteGsmStock}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateGsmStock}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.gsmStockId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default GsmStockList;